import { render, staticRenderFns } from "./render-html.vue?vue&type=template&id=07b81eea&"
import script from "./render-html.vue?vue&type=script&lang=ts&"
export * from "./render-html.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports